var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 135.151c6.85-18.989 25.03-32.563 46.381-32.563 22.316 0 41.168 14.829 47.24 35.171-11.617 11.762-27.753 19.051-45.592 19.051-19.122 0-36.288-8.376-48.029-21.659Z",
    fill: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.065 50.282c0-5.7 4.62-10.32 10.32-10.32h45.273c5.699 0 10.319 4.62 10.319 10.32v18.642c0 18.2-14.755 32.955-32.956 32.955-18.2 0-32.956-14.754-32.956-32.955V50.282Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.047 85.901a5.992 5.992 0 0 1 5.992-5.992H82.02a5.992 5.992 0 0 1 5.992 5.992v16.977c0 7.17-5.812 12.983-12.983 12.983-7.17 0-12.982-5.813-12.982-12.983V85.901Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.578 44.67 10.4 13.267c3.398-5.991 4.596-17.072 2.996-21.97-1.6-4.899-6.732-7.625-9.398-5.584-4.665-5.103-16.396-15.513-25.994-16.33-9.598-.816-14.875 7.845-13.542 11.927-1.333-1.36-4.98-4.36-16.978-5.992-14.996-2.041-10.986 22.97-2.995 29.96 3.25 2.844 13.52-2.557 17.52-5.278.999.68 4.998 2.245 12.996 3.061 7.999.817 19.996-1.7 24.995-3.061Z",
    fill: "#757F9B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.981,
    cy: 67.925,
    rx: 7.989,
    ry: 9.987,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.74,
    cy: 67.927,
    rx: 7.989,
    ry: 9.987,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92A0B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverMaleIcon);
export default __webpack_public_path__ + "static/media/receiver-male-icon.94c8059ce90002e1ce09b21a861d7bfd.svg";
export { ForwardRef as ReactComponent };